import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-251" data-mp="35352e4xiu0lp">
      <a href="#inhoud" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-white focus:px-4 focus:py-2" data-id="element-252" data-mp="3a1ewec7iev5q">
        Naar de inhoud
      </a>
      <Header data-id="element-253" data-mp="3j2mkk1gbafm3" />
      <main id="inhoud" className="flex-1" data-id="element-254" data-mp="3j11x0vsezwxq">
        <Outlet data-id="element-255" data-mp="1kobek0l8gw5k" />
      </main>
      <Footer data-id="element-256" data-mp="1kp4ccc27sbbk" />
    </div>;
}